import { CollectSampleProps } from "@/common/types";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { updateKitStatus } from "@/redux/actions/testKitActions";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

const CollectSample: React.FC<CollectSampleProps> = ({
  testKitId,
  callback,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const params = useParams();
  const dispatch: any = useDispatch();

  const handleSubmit = () => {
    const payload = {
      status: "SAMPLE_COLLECTED",
    };
    const kitId = testKitId ? testKitId : Number(params.id);
    dispatch(
      updateKitStatus(Number(kitId), payload, () => {
        setIsOpen(false);
        if (callback) {
          callback();
        }
      })
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary">Collect Sample</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Collect Sample</DialogTitle>
          <DialogDescription>
            Collect the sample from the patient.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="submit" onClick={() => handleSubmit()}>
            {" "}
            Collect
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CollectSample;
